var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3C91D4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.1111V8H7V22H23V11.1111H15ZM10.2 20.4444H8.6V18.8889H10.2V20.4444ZM10.2 17.3333H8.6V15.7778H10.2V17.3333ZM10.2 14.2222H8.6V12.6667H10.2V14.2222ZM10.2 11.1111H8.6V9.55556H10.2V11.1111ZM13.4 20.4444H11.8V18.8889H13.4V20.4444ZM13.4 17.3333H11.8V15.7778H13.4V17.3333ZM13.4 14.2222H11.8V12.6667H13.4V14.2222ZM13.4 11.1111H11.8V9.55556H13.4V11.1111ZM21.4 20.4444H15V18.8889H16.6V17.3333H15V15.7778H16.6V14.2222H15V12.6667H21.4V20.4444ZM19.8 14.2222H18.2V15.7778H19.8V14.2222ZM19.8 17.3333H18.2V18.8889H19.8V17.3333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.f0dec5b789b95904d11e641d24b69313.svg";
export { ForwardRef as ReactComponent };